





































import AbpBase from "@/lib/abpbase";
import { Component, Prop } from "vue-property-decorator";
import {
  DeleteAssessResult,
  GetAssessFormTableColumns,
  GetAssessResult,
  GetFormSetting,
  InsertAssessResult,
  QueryAssessResultPageList,
  UpdateAssessResult,
} from "@/api/assessForm";

/**
 * 配置表单数据列表页面
 */
@Component
export default class extends AbpBase {
  @Prop() formId: string;
  tableData: any = [];
  columns: any = [];
  loading = false;
  totalCount: number = 0;
  pageRequest: any = {
    page: 1,
    pageSize: 10,
  };
  addOrEditShow = false;
  configFormData: any;
  currentAssessResult: any = null;
  mode: string = "add";
  title: string = "表单名称";

  created() {
    this.getColumns();
  }

  pageChange(val) {
    this.pageRequest.page = val;
    this.getData();
  }

  async getColumns() {
    this.loading = true;
    let res = await GetAssessFormTableColumns({ formId: this.formId });
    this.loading = false;
    if (res && res.objects) {
      let colList = [];
      res.objects.forEach((col) => {
        colList.push({
          title: col.label,
          key: col.model,
        });
      });
      this.columns = colList;
    }
  }

  async getData() {
    this.loading = true;
    this.pageRequest.formId = this.formId;
    // this.pageRequest.assessTimeStart = this.formatDate(this.date[0]);
    // this.pageRequest.assessTimeEnd = this.formatDate(this.date[1]);
    this.pageRequest.isJust = false;
    let res = await QueryAssessResultPageList(this.pageRequest);
    let list = [];
    res.items.forEach((item) => {
      if (item.resultJson) {
        let obj = JSON.parse(item.resultJson);
        list.push({ id: item.id, ...obj });
      }
    });
    this.tableData = list;
    this.totalCount = res.totalCount;
    this.loading = false;
  }

  //查询数据
  query() {
    this.pageRequest.page = 1;
    this.getData();
  }

  // 新增表单数据
  async add() {
    this.mode = "add";
    this.addOrEditShow = true;
    this.loading = true;
    let res = await GetFormSetting({ formId: this.formId });
    this.loading = false;
    if (res.data) {
      let formData = res.data;
      if (formData.list) {
        formData.list.forEach((item) => {
          if (item.type == "checkbox") {
            item.defaultValue = [];
          } else {
            if (item.type == "grid") {
              item.columns.forEach((col) => {
                col.list.forEach((citem) => {
                  if (citem.type == "checkbox") {
                    citem.defaultValue = citem.defaultValue.split(",");
                  }
                });
              });
            }
          }
        });
        this.configFormData = formData;
        (this.$refs.dialogForm as any).setFormVal(res.data);
      }
    } else {
      this.$Message.error("未读取到表单配置信息");
    }
  }

  //编辑表单数据
  async edit(row: any) {
    this.mode = "edit";
    this.addOrEditShow = true;
    this.loading = true;
    //读取患者已有评估记录
    let assessResult = await GetAssessResult({ id: row.id });
    let res = await GetFormSetting({ formId: this.formId });
    this.loading = false;
    if (res.data) {
      let formData = res.data;
      if (formData.list) {
        formData.list.forEach((item) => {
          if (item.type == "checkbox") {
            item.defaultValue = [];
          }
        });
        this.configFormData = formData;
        let refForm = this.$refs.dialogForm as any;
        refForm.setFormVal(res.data);
        if (assessResult.data) {
          this.currentAssessResult = assessResult.data;
          refForm.loadFormData(assessResult.data.resultJson);
        }
      }
    }
  }

  // 删除表单数据
  del(row: any) {
    this.$Modal.confirm({
      title: "提示",
      content: "确定要删除吗？",
      onOk: async () => {
        await DeleteAssessResult(row.id);
        this.getData();
      },
    });
  }

  //保存表单结果
  async saveAssessResult() {
    if (this.$refs.dialogForm) {
      (this.$refs.dialogForm as any).getFormVal().then(async (data) => {
        console.log(data);
        let json = JSON.stringify(data, null, 1);
        let payload: any = {
          formId: this.configFormData.config.id,
          resultJson: json,
        };
        let res: any;
        if (this.mode == "edit") {
          //修改
          payload.id = this.currentAssessResult.id;
          res = await UpdateAssessResult(payload);
        } else {
          //新增
          res = await InsertAssessResult(payload);
        }
        if (res.code === 2000) {
          this.$Message.info("保存成功");
          this.addOrEditShow = false;
          this.query();
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/tool/formBuilder/formTable.vue